export default [
  {
    label: 'CNPJ/CPF', field: 'cadastroFederal', tdClass: 'nowrap', thClass: 'cadastro',
  },
  {
    label: 'Razão social', field: 'razaoSocial',
  },
]
